module.exports = __webpack_public_path__ + "img/arrow_down.f665a567.png";